import { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { ToggleButton, ToggleButtonGroup } from '@zillow/constellation-10';
import { IconListBulletedOutline, IconSparkleOutline } from '@zillow/constellation-icons';
import { useRentalManagerUser } from '@zg-rentals/rental-manager-env';

import { Lease } from '../models';
import { LEASE_VIEW_TYPES } from '../models/Lease';
import { emitListViewClickEvent, emitWizardViewClickEvent } from '../../analytics/events';
import { useLeaseQuery, useWebAnalyticsForListingQuery } from '../utils/queries';
import { useLeasingUrlParams } from '../hooks/useLeasingUrlParams';

function LeaseViewModeToggle(): JSX.Element {
  const { user } = useRentalManagerUser();
  const history = useHistory();
  const { leaseId, viewType, propertyId } = useLeasingUrlParams();

  const { data: lease } = useLeaseQuery(leaseId);

  const isAtSummary = viewType === LEASE_VIEW_TYPES.SUMMARY;
  const isEditable = lease ? !lease.isReadOnly() : false;
  const isInSigningState = lease ? !lease.isInSigningState() : false;

  const WIZARD_VIEW = 'wizard-view';
  const LIST_VIEW = 'list-view';

  const [view, setView] = useState(isAtSummary ? LIST_VIEW : WIZARD_VIEW);

  const webAnalyticsQuery = useWebAnalyticsForListingQuery(propertyId, { enabled: !!propertyId });
  const zrm_listing_info = webAnalyticsQuery.data;

  function gotoWizard(): void {
    history.push(Lease.getWizardPath(leaseId));
  }

  function gotoSummary(): void {
    history.push(Lease.getSummaryPath(leaseId));
  }

  return (
    <ToggleButtonGroup
      value={view}
      onValueChange={(value) => {
        const newValue = typeof value === 'string' ? value : value[0];
        if (newValue === WIZARD_VIEW) {
          emitWizardViewClickEvent({ user, listing: zrm_listing_info });
          gotoWizard();
        } else {
          emitListViewClickEvent({ user, listing: zrm_listing_info });
          gotoSummary();
        }
        setView(newValue);
      }}
      aria-label="Wizard list toggle"
    >
      <ToggleButton value={WIZARD_VIEW} icon={<IconSparkleOutline />} disabled={!isEditable || !isInSigningState}>
        Wizard view
      </ToggleButton>
      <ToggleButton value={LIST_VIEW} icon={<IconListBulletedOutline />} disabled={!isEditable || !isInSigningState}>
        List view
      </ToggleButton>
    </ToggleButtonGroup>
  );
}

export default LeaseViewModeToggle;
